import React, {
  useState,
  useEffect,
  useMemo,
  useCallback,
  useRef,
} from "react";
import "bootstrap/dist/css/bootstrap.css";
import ContactLoader from "views/ContantLoader";
import { Container } from "reactstrap";
import "bootstrap/dist/css/bootstrap.css";
import Tooltip from "react-bootstrap/Tooltip";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import Table from "../../../Table";
import ContantLoader from "views/ContantLoader";
import "./tabs.css"
import { getActivityApi, getActivityCountApi } from 'api/SalesApi'
import {
  setCampaignId,
  setCampaignViewMode,
  resetCampaignData,
} from 'ReduxStore/Slices/campaignSlice';
import { useSelector, useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom'
import { setEventSignalLoading } from "ReduxStore/Slices/eventandsignalSlice";

export default function ActivityTab({ personData }) {
  const [dataApi, setDataApi] = useState([]);
  const [total, setTotal] = useState(-1);
  const [pageCount, setPageCount] = useState(0);
  const [pageIndex, setPageIndex] = useState(0);
  const [loading, setLoading] = useState(false);

  const dispatch = useDispatch();
  const { eventandsignalLoading } = useSelector(
    (state) => state.eventandsignalSetter
  );
  const history = useHistory()

  const searchText = useRef("");
  useEffect(() => {
    dispatch(setEventSignalLoading(true));

  }, []);

  const fetchData = useCallback(async ({ pageSize, pageIndex }) => {
    dispatch(setEventSignalLoading(true));
    setLoading(true);
    const startRow = pageSize * pageIndex;
    const endRow = startRow + pageSize;
    setPageIndex(pageIndex);

    await getActivityCountApi(personData.id)
      .then((data) => {
        setPageCount(Math.ceil(data.count / pageSize));
        setTotal(data.count);
        setLoading(false);
      })
      .catch((e) => { });

    await getActivityApi(personData.id, pageSize, startRow)
      .then((data) => {
        setDataApi(data);
        setLoading(false);
      })

  }, []);

  const navigateToDetails = (activity) => {
    let id = activity.referenceId
    if (activity.type != 'event') {
      dispatch(setCampaignId(id));
      dispatch(setCampaignViewMode(true));
      history.push('/admin/campaign/create')

    }
    else {
      history.push(`/admin/triggersAndEvents/createEvent?event=${id}`)

    }
  }

  function getReferenceLink(activity) {
    return <a onClick={(e) => { e.stopPropagation(); navigateToDetails(activity) }} style={{ color: '#007bff' }} title={activity.referenceName}><p style={{
      overflow: 'hidden', maxWidth: '30vw', marginBottom: 0
    }}>{activity.referenceName} </p></a>
  }
  function getWebpageUrlLink(activity, on = true) {
    if (!activity.webpageUrl)
      return ''

    return <>
      {on && <span className="mx-1"> on</span>}
      <a target="_blank" href={activity.webpageUrl} style={{ color: '#007bff' }} title={activity.webpageUrl} >
        <p style={{
          overflow: 'hidden', maxWidth: '30vw', marginBottom: 0
        }}>{activity.webpageUrl} </p></a >
    </>
  }

  function getLink(activity) {
    return <a target="_blank" href={activity.link} style={{ color: '#007bff' }} title={activity.link}><p style={{
      overflow: 'hidden', maxWidth: '30vw', marginBottom: 0
    }}>{activity.link} </p></a>
  }

  const buildActivityMsg = (activity) => {
    let map = {
      'campaignemailopen': { title: 'Email Tracking', description: <>	Opened {getReferenceLink(activity)} </> },
      'campaignemailclick': { title: 'Email Tracking', description: <>Clicked {getLink(activity)} in {getReferenceLink(activity)} </> },
      'campaignemailsend': { title: 'Email Tracking', description: <>Sent {getReferenceLink(activity)} </> },
      'campaignemailbounce': { title: 'Email Tracking', description: <> Bounced {getReferenceLink(activity)} </> },
      'campaignemailunsubscribe': { title: 'Email Tracking', description: <>	Unsubscribed through {getReferenceLink(activity)} </> },
      'campaignwebpageview': { title: 'Web Tracking', description: <>	Visited {getReferenceLink(activity)}  {getWebpageUrlLink(activity)} </> },
      'campaignwebpageclick': { title: 'Web Tracking', description: <>	Clicked {getLink(activity)} in {getReferenceLink(activity)} {getWebpageUrlLink(activity)} </> },
      'eventwebpagepage view': { title: 'Web Tracking', description: <>	visited {getWebpageUrlLink(activity)} through  {getReferenceLink(activity)} </> },
      'eventwebpageform submission': { title: 'Web Tracking', description: <>	Submitted Form in {getWebpageUrlLink(activity, false)} through  {getReferenceLink(activity)}   </> },
      'eventwebpageinput textbox': { title: 'Web Tracking', description: <> Entered Textbox in {getWebpageUrlLink(activity, false)} through  {getReferenceLink(activity)}   </> },
      'eventwebpageclicks': { title: 'Web Tracking', description: <>	Clicked {getLink(activity)} in {getWebpageUrlLink(activity, false)} through  {getReferenceLink(activity)}  </> },
      'eventwebpagetrigger': { title: 'Web Tracking', description: <> 	Trigggered {getReferenceLink(activity)} in {getWebpageUrlLink(activity, false)}</> },
      'eventcustomtrigger': { title: 'Event', description: <> 	Trigggered {getReferenceLink(activity)}</> },
      'eventgoalconvert': { title: 'Goal', description: <>Converted {getReferenceLink(activity)}  {getWebpageUrlLink(activity)}</> },
      'campaigncalculatoruse': { title: 'Calculator', description: <>Used {getReferenceLink(activity)}  {getWebpageUrlLink(activity)} </> },
      'campaignofferview': { title: 'Offer', description: <>	Viewed {getReferenceLink(activity)}  {getWebpageUrlLink(activity)} </> },
      'campaignofferclick': { title: 'Offer', description: <> Clicked {activity.link} in {getReferenceLink(activity)}  {getWebpageUrlLink(activity)}</> },
      'salesmeetingcreate': { title: 'Meeting', description: <> { activity.owner} created a meeting</>}
    }
    let key = `${activity.type}${activity.subType}${activity.activityType}`

    return map[key]
  }


  const data = useMemo(() => dataApi, [dataApi]);
  const columns = useMemo(
    () => [


      {
        Header: "",
        accessor: "_",
        Cell: ({ cell }) => {
          let activity = cell.row.original
          let builtMsg = buildActivityMsg(activity)

          if (!builtMsg)
            return ''
          return <div className='ac-main' onClick={(e) => {

          }}>
            <div className='ac-title' >
              <div style={{ display: 'flex' }}>
                <div className='ac-name'> {builtMsg.title}</div>
                {/* <div style={{ display: 'flex' }}>
                  <div className='ac-tag'>{activity.subType }</div>
                  <div className='ac-tag'>{activity.activityType }</div>
              </div> */}
              </div>
   
            </div>
            <div className='ac-body'>

              {builtMsg.description}

            </div>

            <div className='ac-date'>
                <i class="fa fa-calendar" aria-hidden="true"></i>
                <span className="ml-1">{activity.createdAt && activity.createdAt.split('T')[0]}</span>
              </div>

          </div>
        }
      },

    ],
    [dataApi]
  );

  return (
    <>
    {
      loading ? (
        <ContactLoader />
      ) : (
    <Container id='activity'>
      <div className="">

      </div>
      <div></div>
      {dataApi ? (
        <div className="dataTableOuter" style={{ paddingBottom: "20px" }}>
          {total == 0 ?
            <div
              style={{
                textAlign: 'center',
                padding: '40px',
                fontWeight: 900,
                fontSize: '19px',
                fontFamily: 'DM Sans'
              }}

            >No activities to show.</div>
            :
            <Table
              columns={columns}
              data={data}
              pageCount={pageCount}
              loading={loading}
              fetchData={fetchData}
            //loading={eventandsignalLoading}
            ></Table>
          }

        </div>
      ) : (
        <ContactLoader />
      )}
    </Container>
    )
  }
    </>
  );
}
